export const IconHome = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M4 11.5 12 4l8 7.5V20a1 1 0 0 1-1 1h-5v-6H10v6H5a1 1 0 0 1-1-1v-8.5Z" />
  </svg>
);

export const IconCam = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <rect x="3" y="7" width="13" height="10" rx="2" />
    <path d="m16 10 5-2v8l-5-2" />
  </svg>
);

export const IconUsers = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <circle cx="9" cy="8" r="3" />
    <path d="M3.5 19c.6-3 2.8-4.5 5.5-4.5S14 16 14.5 19" />
    <circle cx="17" cy="9" r="2.4" />
    <path d="M16 19c.3-2 1.6-3.2 3.6-3.6" />
  </svg>
);

export const IconLogout = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M10 7V5a1 1 0 0 1 1-1h8v16h-8a1 1 0 0 1-1-1v-2" />
    <path d="M4 12h10M11 8l4 4-4 4" />
  </svg>
);

export const IconTrend = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M4 16 10 10l4 4 6-8" />
    <path d="M15 6h5v5" />
  </svg>
);

export const IconHealth = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M4 12h4l2-5 4 10 2-5h4" />
    <rect x="3" y="4" width="18" height="16" rx="2" />
  </svg>
);

export const IconLive = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <rect x="3" y="6" width="18" height="12" rx="2" />
    <path d="M10 10.5v3l3.5-1.5L10 10.5Z" fill="currentColor" stroke="none" />
  </svg>
);

export const IconUptime = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <circle cx="12" cy="12" r="8" />
    <path d="M12 8v4l3 2" />
  </svg>
);
